import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { setAppointmentCounts } from "../reduxtool/action";
import logo from "../images/logoNew.png";
import Avtar from "../images/profile.svg";
import reschedule from "../images/reschedule1.svg";
import cancel from "../images/cancel1.svg";
import { FaArrowRightLong, FaRegBell } from "react-icons/fa6";
import { IoSettingsOutline } from "react-icons/io5";
import { LuNotepadText } from "react-icons/lu";
import { IoMdCalendar } from "react-icons/io";
import { RiCalendarCloseLine, RiHome6Line } from "react-icons/ri";
import { LiaHourglassHalfSolid } from "react-icons/lia";
import { LuCalendarCheck } from "react-icons/lu";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { IoMdSearch } from "react-icons/io";
import { BiLogOut } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import DoctorAppointmentSlot from "./DoctorAppointmentSlot";
import PatientProfilePopup from "../DoctorDashboard/PatientProfile";
import { MdCallMissed } from "react-icons/md";
import { GiHamburgerMenu } from "react-icons/gi";
import { FaUserDoctor } from "react-icons/fa6";
import { CrmDashboards } from "./CrmDashboards";
import SlotsDoctorAvailability from "./DoctorManagement";
import { FaArrowRight } from "react-icons/fa";
import PaginationControls from "./PaginationControls";
import "../ScrollBar/ScrollBar.css";
import { useDispatch } from "react-redux";
import HomePageDoctorCalender from "./HomePageDoctorCalender";
import { decryptData } from "../Services/TabServices";
import CrmProfile from "./CrmProfile";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import { TextField } from "@mui/material";

interface Appointment {
  appointmentId: string;
  patientName: string;
  doctorName: string;
  specializationName: string;
  formattedDate: string;
  formattedTime: string;
  age: number;
  gender: string;
  appointmentDate: string;
  slotStartTime: string;
  slotEndTime: string;
  email: string;
  // Add any other fields used in your component
}

type doctors = {
  id: number;
  name: string;
  speciality: string;
  experience: string;
};

type Doctor = {
  doctorId: number;
  doctorName: string;
  specializationName: string;
};

const CrmDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const prevCountsRef = useRef<any>(null);
  // const CrmID = sessionStorage.getItem("userId");
  const storedUserId = sessionStorage.getItem("userId");
  const CrmID = storedUserId ? decryptData(storedUserId) : null;
  const token = sessionStorage.getItem("token");
  const count = useSelector((state: any) => state.appointmentCounts);

  const doctors = [
    {
      id: 1,
      name: "Dr. Smith",
      speciality: "Cardiology",
      experience: "10 yrs",
    },
    { id: 3, name: "Dr. Jane", speciality: "Dermatology", experience: "8 yrs" },
  ];
  const [selectedAppointmentId, setSelectedAppointmentId] = useState<
    string | null
  >(null);
  const [loading, setLoading] = useState(false);
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [patientId, setPatientId] = useState<string | null>(null);
  const [CrmAdminProfile, setAdminProfile] = useState<any>([]);
  const [upcommingAppointments, setUpcommingAppointments] = useState<any>([]);
  const [cancelledAppointments, setCancelledAppointments] = useState<
    Appointment[]
  >([]);
  const [missedAppointments, setMissedAppointments] = useState<Appointment[]>(
    []
  );
  const [completedAppointments, setCompletedAppointments] = useState<
    Appointment[]
  >([]);
  const [pendingAppointments, setPendingAppointments] = useState<Appointment[]>(
    []
  );
  const [todayAppointment, setTodayAppointments] = useState<any>([]);
  const [activeAppointments, setActiveAppointment] = useState<any>([]);
  const [scheduleAppointments, setScheduleAppointment] = useState<any>([]);
  const [rescheduleAppointments, setRescheduleAppointments] = useState<any>([]);
  const [doctorId, setDoctorId] = useState("");
  const [doctorSpeciality, setDoctorSpeciality] = useState("");
  const [selectedDoctorFee, setDoctorFee] = useState<any>([]);
  const [SlectedDoctorId, setSelectedDoctorId] = useState("");
  const [isRecheduleModalOpen, setIsRescheduleModalOpen] = useState(false);
  const [AvailableDoctors, setAvailableDoctors] = useState<Doctor[]>([]);
  const [activePage, setActivePage] = useState<string>(
    () => sessionStorage.getItem("activepage") || "Home"
  );
  const [searchTerm, setSearchTerm] = useState("");
  const [filters, setFilters] = useState({
    speciality: "",
    doctor: "",
    date: "",
    priority: "",
  });
  const [rescheduleOption, setRescheduleOption] = useState("same");
  const [selectedDoctor, setSelectedDoctor] = useState<doctors | null>(
    doctors.length > 0 ? doctors[0] : null
  );
  const [loadingAppointmentId, setLoadingAppointmentId] = useState<
    string | null
  >(null);
  const [specialities, setSpecialities] = useState([]);
  const [dateRangeFilter, setDateRangeFilter] = useState<
    "today" | "week" | "month" | "custom" | ""
  >("");
  const [customDateRange, setCustomDateRange] = useState<{
    from: string;
    to: string;
  }>({
    from: "",
    to: "",
  });
  const [showDateFilterPopup, setShowDateFilterPopup] = useState(false);
  const [searchPatient, setSearchPatient] = useState("");
  const [searchDoctor, setSearchDoctor] = useState("");
  const [searchDate, setSearchDate] = useState("");
  const [cancelReason, setCancelReason] = useState("");
  const [cancelRemark, setCancelRemark] = useState("");
  const [error, setError] = useState("");
  const [isCrmProfileModalOpen, setIsCrmProfileModalOpen] = useState(false);

const [showLogoutModal, setShowLogoutModal] = useState(false);


const handleLogoutClick = () => setShowLogoutModal(true);

const handleCancelLogout = () => setShowLogoutModal(false);

const handleConfirmLogout = () => {
  setShowLogoutModal(false);
  handleLogout(); 
};

  useEffect(() => {
    const fetchSpecialities = async () => {
      try {
        const response: any = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/Patient/GetSpecialization`
        );
        if (response?.data) {
          setSpecialities(response.data);
        } else {
          console.warn("Unexpected API response format", response.data);
        }
      } catch (error) {
        console.error("Failed to fetch specialities:", error);
      }
    };
    fetchSpecialities();
  }, []);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response: any = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/User/GetAdminCrmDetailsById`,
          {
            params: { CrmID: CrmID },
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        if (response?.data) {
          setAdminProfile(response.data);
        } else {
          console.warn("Unexpected API response format", response.data);
        }
      } catch (error) {
        console.error("Failed to fetch specialities:", error);
      }
    };

    fetchProfile();
  }, []);

  const handleDoctorSelect = (doctor: any) => {
    setSelectedDoctor(doctor);
  };

  useEffect(() => {
    const fetchRescheduledData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/Patient/rescheduled-appointments`,
          {
            params: {
              CRMId: CrmID,
            },
          }
        );

        const now = new Date();
        const updatedAppointments = response.data.map((item: any) => {
          const dob = new Date(item.age);
          const age = Math.floor(
            (now.getTime() - dob.getTime()) / (1000 * 60 * 60 * 24 * 365.25)
          );
          const originalDateTime = new Date(
            `${item.appointmentDate}T${item.originalSlotStartTime}`
          );
          const formattedDate = originalDateTime.toLocaleDateString("en-US", {
            day: "2-digit",
            month: "short",
          });
          const formattedTime = originalDateTime.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
          const newDateTime = new Date(
            `${item.newAppointmentDate}T${item.newSlotStartTime}`
          );
          const newformattedDate = newDateTime.toLocaleDateString("en-US", {
            day: "2-digit",
            month: "short",
          });
          const newformattedTime = newDateTime.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });
          return {
            ...item,
            age,
            formattedDate,
            formattedTime,
            newformattedDate,
            newformattedTime,
          };
        });
        const sortedAppointments = updatedAppointments.sort(
          (a: any, b: any) =>
            new Date(
              `${b.appointmentDate}T${b.originalSlotStartTime}`
            ).getTime() -
            new Date(
              `${a.appointmentDate}T${a.originalSlotStartTime}`
            ).getTime()
        );
        setRescheduleAppointments(sortedAppointments);
      } catch (error) {
        console.error("Error fetching rescheduled data:", error);
      }
    };
    if (activePage === "Rescheduled") {
      fetchRescheduledData();
    }
  }, [activePage]);
  const isSameDate = (date1: Date, date2: Date) => {
    return (
      date1.toISOString().split("T")[0] === date2.toISOString().split("T")[0]
    );
  };

  const isThisWeek = (date: Date) => {
    const today = new Date();
    const first = new Date(today.setDate(today.getDate() - today.getDay()));
    const last = new Date(first);
    last.setDate(first.getDate() + 6);
    first.setHours(0, 0, 0, 0);
    last.setHours(23, 59, 59, 999);
    return date >= first && date <= last;
  };

  const isThisMonth = (date: Date) => {
    const today = new Date();
    return (
      date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth()
    );
  };

  const isInCustomRange = (date: Date, from: string, to: string) => {
    if (!from || !to) return true;
    const start = new Date(from);
    const end = new Date(to);
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);
    return date >= start && date <= end;
  };

  const getAppointmentsByPage = () => {
    let appointments = [];
    switch (activePage) {
      case "Confirm":
        appointments = pendingAppointments;
        break;
      case "Upcoming":
        appointments = upcommingAppointments;
        break;
      case "Today":
        appointments = todayAppointment;
        break;
      case "Active":
        appointments = activeAppointments;
        break;
      case "Scheduled":
        appointments = scheduleAppointments;
        break;
      case "Rescheduled":
        appointments = rescheduleAppointments;
        break;
      case "Cancelled":
        appointments = cancelledAppointments;
        break;
      case "Completed":
        appointments = completedAppointments;
        break;
      case "Missed":
        appointments = missedAppointments;
        break;
      default:
        appointments = [];
    }
    if (searchTerm.trim()) {
      appointments = appointments.filter(
        (item: any) =>
          item.patientName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.appointmentId.toString().includes(searchTerm) ||
          item.doctorName?.toLowerCase().includes(searchTerm) ||
          item.specializationName?.toLowerCase().includes(searchTerm)
      );
    }

    if (filters.speciality) {
      appointments = appointments.filter((item: any) =>
        item.specializationName
          .toLowerCase()
          .includes(filters.speciality.toLowerCase())
      );
    }

    if (filters.doctor) {
      appointments = appointments.filter((item: any) =>
        item.doctorName.toLowerCase().includes(filters.doctor.toLowerCase())
      );
    }

    if (filters.date) {
      appointments = appointments.filter(
        (item: any) => item.appointmentDate === filters.date
      );
    }

    if (filters.priority) {
      appointments = appointments.filter(
        (item: any) =>
          item.priority?.toLowerCase() === filters.priority.toLowerCase()
      );
    }
    if (dateRangeFilter) {
      appointments = appointments.filter((item: any) => {
        let appointmentDate;

        if (activePage === "Rescheduled") {
          appointmentDate = new Date(
            `${item.newAppointmentDate}T${item.newSlotStartTime}`
          );
        } else {
          appointmentDate = new Date(
            `${item.appointmentDate}T${item.slotStartTime}`
          );
        }

        switch (dateRangeFilter) {
          case "today":
            return isSameDate(appointmentDate, new Date());
          case "week":
            return isThisWeek(appointmentDate);
          case "month":
            return isThisMonth(appointmentDate);
          case "custom":
            return isInCustomRange(
              appointmentDate,
              customDateRange.from,
              customDateRange.to
            );
          default:
            return true;
        }
      });
    }

    return appointments;
  };
  const getFilteredCounts = () => {
    const applyFilters = (appointments: any[]) => {
      let filtered = appointments;

      if (searchTerm.trim()) {
        filtered = filtered.filter(
          (item: any) =>
            item.patientName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.appointmentId.toString().includes(searchTerm) ||
            item.doctorName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item.specializationName
              ?.toLowerCase()
              .includes(searchTerm.toLowerCase())
        );
      }

      if (filters.speciality) {
        filtered = filtered.filter((item: any) =>
          item.specializationName
            .toLowerCase()
            .includes(filters.speciality.toLowerCase())
        );
      }

      if (dateRangeFilter) {
        filtered = filtered.filter((item: any) => {
          let appointmentDate;

          if (item.newAppointmentDate) {
            appointmentDate = new Date(
              `${item.newAppointmentDate}T${item.newSlotStartTime}`
            );
          } else {
            appointmentDate = new Date(
              `${item.appointmentDate}T${item.slotStartTime}`
            );
          }

          switch (dateRangeFilter) {
            case "today":
              return isSameDate(appointmentDate, new Date());
            case "week":
              return isThisWeek(appointmentDate);
            case "month":
              return isThisMonth(appointmentDate);
            case "custom":
              return isInCustomRange(
                appointmentDate,
                customDateRange.from,
                customDateRange.to
              );
            default:
              return true;
          }
        });
      }

      return filtered.length;
    };

    return {
      Confirm: applyFilters(pendingAppointments),
      Scheduled: applyFilters(scheduleAppointments),
      Active: applyFilters(activeAppointments),
      Rescheduled: applyFilters(rescheduleAppointments),
      Completed: applyFilters(completedAppointments),
      Cancelled: applyFilters(cancelledAppointments),
      Missed: applyFilters(missedAppointments),
    };
  };
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  const allAppointments = getAppointmentsByPage();
  const totalPages = Math.ceil(allAppointments.length / itemsPerPage);
  const currentAppointments = allAppointments.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [activePage]);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, filters, dateRangeFilter, customDateRange]);

  useEffect(() => {
    sessionStorage.setItem("activepage", activePage);
  }, [activePage]);

  useEffect(() => {
    const fetchCrmAppointmentList = async () => {
      try {
        const [allResponse, rescheduledResponse] = await Promise.all([
          axios.get(
            `${process.env.REACT_APP_BASE_URL}/api/User/GetAppointmentComputeByCRM`,
            {
              params: { CrmID: CrmID },
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          ),
          axios.get(
            `${process.env.REACT_APP_BASE_URL}/api/Patient/rescheduled-appointments`,
            {
              params: { CRMId: CrmID },
            }
          ),
        ]);
        const doctorAppointment = allResponse.data;
        const now = new Date();
        const updatedAppointments = doctorAppointment.map((item: any) => {
          const dob = new Date(item.dob);
          const age = Math.floor(
            (now.getTime() - dob.getTime()) / (1000 * 60 * 60 * 24 * 365.25)
          );
          const appointmentDateTime = new Date(
            `${item.appointmentDate}T${item.slotStartTime}`
          );

          const formattedDate = appointmentDateTime.toLocaleDateString(
            "en-US",
            {
              day: "2-digit",
              month: "short",
            }
          );

          const formattedTime = appointmentDateTime.toLocaleTimeString(
            "en-US",
            {
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            }
          );

          return {
            ...item,
            age,
            formattedDate,
            formattedTime,
          };
        });
        const missedAppointments: any[] = [];
        const categorizedAppointments = updatedAppointments.reduce(
          (acc: any, item: any) => {
            const appointmentDateTime = new Date(
              `${item.appointmentDate}T${item.slotEndTime}`
            );
            const isPast = appointmentDateTime < now;
            const shouldBeMissed =
              isPast &&
              item.flag !== "R" &&
              item.flag !== "C" &&
              item.flag !== "D";
            if (shouldBeMissed) {
              missedAppointments.push(item);
            } else {
              if (item.flag === "A") acc.pending.push(item);
              else if (item.flag === "S") acc.scheduled.push(item);
              // else if (item.flag === "R") acc.reschedule.push(item);
              else if (item.flag === "C") acc.cancelled.push(item);
              else if (item.flag === "D") acc.completed.push(item);
            }
            return acc;
          },
          {
            pending: [],
            scheduled: [],
            reschedule: [],
            cancelled: [],
            completed: [],
          }
        );

        const nowTime = new Date();

        const activeAppointments = updatedAppointments.filter((item: any) => {
          const appointmentStartTime = new Date(
            `${item.appointmentDate}T${item.slotStartTime}`
          );
          const appointmentEndTime = new Date(
            `${item.appointmentDate}T${item.slotEndTime}`
          );

          const thirtyMinutesBeforeStart = new Date(
            appointmentStartTime.getTime() - 30 * 60000
          );
          return (
            item.flag === "S" &&
            nowTime >= thirtyMinutesBeforeStart &&
            nowTime <= appointmentEndTime &&
            item.meetLink
          );
        });

        const currentDate = new Date().toISOString().split("T")[0];
        const todayAppointments = updatedAppointments
          .filter((item: any) => item.appointmentDate === currentDate)
          .map((item: any) => {
            const appointmentDateTime = new Date(
              `${item.appointmentDate}T${item.slotStartTime}`
            );
            const timeDiffInMinutes =
              (appointmentDateTime.getTime() - now.getTime()) / (1000 * 60);

            return {
              ...item,
              canStartMeeting:
                timeDiffInMinutes <= 30 && timeDiffInMinutes >= 0,
            };
          })
          .sort(
            (a: any, b: any) =>
              new Date(`${a.appointmentDate}T${a.slotStartTime}`).getTime() -
              new Date(`${b.appointmentDate}T${b.slotStartTime}`).getTime()
          );

        const upcommingAppointments = todayAppointments
          .filter(
            (item: any) =>
              new Date(`${item.appointmentDate}T${item.slotStartTime}`) >
              new Date()
          )
          .sort(
            (a: any, b: any) =>
              new Date(`${a.appointmentDate}T${a.slotStartTime}`).getTime() -
              new Date(`${b.appointmentDate}T${b.slotStartTime}`).getTime()
          )
          .slice(0, 2);

        const sortByDateTime = (a: any, b: any) =>
          new Date(`${b.appointmentDate}T${b.slotStartTime}`).getTime() -
          new Date(`${a.appointmentDate}T${a.slotStartTime}`).getTime();
        setUpcommingAppointments(upcommingAppointments);
        setTodayAppointments(todayAppointments);
        setMissedAppointments(missedAppointments.sort(sortByDateTime));
        setCancelledAppointments(
          categorizedAppointments.cancelled.sort(sortByDateTime)
        );
        setCompletedAppointments(
          categorizedAppointments.completed.sort(sortByDateTime)
        );
        setPendingAppointments(
          categorizedAppointments.pending.sort(sortByDateTime)
        );
        // setRescheduleAppointments(
        //   categorizedAppointments.reschedule.sort(sortByDateTime)
        // );
        setActiveAppointment(activeAppointments.sort(sortByDateTime));
        setScheduleAppointment(
          categorizedAppointments.scheduled.sort(sortByDateTime)
        );

        const updatedReschedules = rescheduledResponse.data.map((item: any) => {
          const now = new Date();
          const dob = new Date(item.age);
          const age = Math.floor(
            (now.getTime() - dob.getTime()) / (1000 * 60 * 60 * 24 * 365.25)
          );

          const originalDateTime = new Date(
            `${item.appointmentDate}T${item.originalSlotStartTime}`
          );
          const formattedDate = originalDateTime.toLocaleDateString("en-US", {
            day: "2-digit",
            month: "short",
          });
          const formattedTime = originalDateTime.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });

          const newDateTime = new Date(
            `${item.newAppointmentDate}T${item.newSlotStartTime}`
          );
          const newformattedDate = newDateTime.toLocaleDateString("en-US", {
            day: "2-digit",
            month: "short",
          });
          const newformattedTime = newDateTime.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
          });

          return {
            ...item,
            age,
            formattedDate,
            formattedTime,
            newformattedDate,
            newformattedTime,
          };
        });

        setRescheduleAppointments(
          updatedReschedules.sort(
            (a: any, b: any) =>
              new Date(
                `${b.appointmentDate}T${b.originalSlotStartTime}`
              ).getTime() -
              new Date(
                `${a.appointmentDate}T${a.originalSlotStartTime}`
              ).getTime()
          )
        );
      } catch (error: any) {
        console.error("error in doctor appointment list", error);
        if (error.response && error.response.status === 401) {
          navigate("/crmLogin");
        }
      }
    };
    fetchCrmAppointmentList();
  }, [activePage]);
  useEffect(() => {
    const fetchDoctorAvailability = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/Patient/GetDoctorAvailability`
        );
        const data = response.data;
        const doctorFee = selectedDoctorFee;
        const availableDoctors = data.filter(
          (doc: any) =>
            doc.doctorFees <= doctorFee &&
            doc.specializationName == doctorSpeciality
        );
        setAvailableDoctors(availableDoctors);
      } catch (err) {
        console.error("Error fetching doctor availability:", err);
      }
    };
    fetchDoctorAvailability();
  }, [doctorId, selectedDoctorFee]);
  const handleLogout = () => {
    sessionStorage.removeItem("userType");
    sessionStorage.removeItem("userId");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("activepage");
    navigate("/crmLogin");
  };
  const handleMeetGenerate = async (
    appointmentId: any,
    date: string,
    start: string,
    end: string,
    pEmail: any,
    DEmail: any,
    doctorName: any,
    patientName: any
  ) => {
    const startDateTime = `${date}T${start}`;
    const endDateTime = `${date}T${end}`;

    try {
      setLoadingAppointmentId(appointmentId);
      const meetResponse: any = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/appointments/${appointmentId}/confirm`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const meetingLink = meetResponse?.data?.data?.hangoutLink;
      if (meetingLink) {
        const payload = {
          appointmentId: appointmentId,
          meetingLink: meetingLink,
          createdBy: CrmID,
        };
        const updatedCounts = {
          Confirm: pendingAppointments.length - 1,
          Scheduled: scheduleAppointments.length + 1,
          Active: activeAppointments.length,
          Rescheduled: rescheduleAppointments.length,
          Completed: completedAppointments.length,
          Cancelled: cancelledAppointments.length,
          Missed: missedAppointments.length,
        };

        dispatch(setAppointmentCounts(updatedCounts));
      }
      setPendingAppointments((prev) =>
        prev.filter((item) => item.appointmentId !== appointmentId)
      );
    } catch (error) {
      console.error("Error during meeting/appointment process:", error);
    } finally {
      setLoadingAppointmentId(null);
    }
  };
  const handleReschedule = (
    doctorId: any,
    doctorFees: any,
    speciality: any
  ) => {
    setIsRescheduleModalOpen(true);
    setDoctorFee(doctorFees);
    setDoctorSpeciality(speciality);
    setSelectedDoctorId(doctorId);
  };

  useEffect(() => {
    if (AvailableDoctors.length > 0 && doctorId == null) {
      const defaultDoctor: any = AvailableDoctors[0];
      setDoctorId(defaultDoctor.doctorId);
      handleDoctorSelect(defaultDoctor);
    }
  }, [AvailableDoctors]);

  const handleCancelAppointment = async () => {
    if (!selectedAppointmentId || !CrmID) return;
    const crmIdInt = parseInt(CrmID, 10);
    
    setLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Appointments/CancelAppointment`,
        {},
        {
          params: {
          id: Number(selectedAppointmentId),
          UserId:crmIdInt,  
          UserTypeId:"C",
          Reason:cancelReason,
          Remark:cancelRemark
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setScheduleAppointment((prev: any) =>
        prev.filter((item: any) => item.appointmentId !== selectedAppointmentId)
      );
      const updatedCounts = {
          Confirm: pendingAppointments.length,
          Scheduled: scheduleAppointments.length,
          Active: activeAppointments.length,
          Rescheduled: rescheduleAppointments.length,
          Completed: completedAppointments.length,
          Cancelled: cancelledAppointments.length +1,
          Missed: missedAppointments.length,
        };

        dispatch(setAppointmentCounts(updatedCounts));
 setShowCancelConfirmation(false);
      setLoading(false);
    } catch (error) {
      console.error("Error in  cancel appointment:", error);
      setLoading(false);
    }
  };
  const filteredAppointments = currentAppointments.filter(
    (appointment: any) => {
      return (
        appointment.patientName
          ?.toLowerCase()
          .includes(searchPatient.toLowerCase()) &&
        appointment.doctorName
          ?.toLowerCase()
          .includes(searchDoctor.toLowerCase()) &&
        appointment.formattedDate
          ?.toLowerCase()
          .includes(searchDate.toLowerCase())
      );
    }
  );

  const newCounts = {
    Confirm: pendingAppointments.length,
    Scheduled: scheduleAppointments.length,
    Active: activeAppointments.length,
    Rescheduled: rescheduleAppointments.length,
    Completed: completedAppointments.length,
    Cancelled: cancelledAppointments.length,
    Missed: missedAppointments.length,
  };

  useEffect(() => {
    if (JSON.stringify(prevCountsRef.current) !== JSON.stringify(newCounts)) {
      dispatch(setAppointmentCounts(newCounts));
      prevCountsRef.current = newCounts;
    }
  }, [
    dispatch,
    pendingAppointments.length,
    scheduleAppointments.length,
    activeAppointments.length,
    rescheduleAppointments.length,
    completedAppointments.length,
    cancelledAppointments.length,
    missedAppointments.length,
  ]);

  return (
    <div className="w-full bg-[#F5F5F5]">
      {/* topBar */}
{showLogoutModal && (
  <div
    className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[100] p-4"
    onClick={handleCancelLogout} // click outside closes
  >
    <div
      className="bg-white rounded-2xl max-w-md w-full shadow-2xl animate-slideUp"
      onClick={(e) => e.stopPropagation()} // prevent outside click close when clicking inside
    >
      {/* Header */}
      <div className="bg-red-100 text-red-600 px-6 py-4 rounded-t-2xl">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-white/20 rounded-full">
            <BiLogOut className="text-xl" />
          </div>
          <h2 className="text-xl font-bold">Confirm Logout</h2>
        </div>
      </div>

      {/* Body */}
      <div className="p-6">
        <p className="text-gray-700 text-center text-lg">
          Are you sure you want to logout?
        </p>
        <p className="text-gray-500 text-center text-sm mt-2">
          You will need to login again to access your account.
        </p>
      </div>

      {/* Footer */}
      <div className="flex gap-3 px-6 pb-6">
        <button
          onClick={handleCancelLogout}
          className="flex-1 px-6 py-2.5 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg font-semibold transition-all"
        >
          Cancel
        </button>
        <button
          onClick={handleConfirmLogout}
          className="flex-1 px-6 py-2.5 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white rounded-lg font-semibold shadow-md hover:shadow-lg transition-all"
        >
          Logout
        </button>
      </div>
    </div>
  </div>
)}

      {isCrmProfileModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
          onClick={() => setIsCrmProfileModalOpen(false)} // click outside to close
        >
          <div
            className="bg-white rounded-md shadow-md p-6 max-w-sm w-full"
            onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
          >
            <CrmProfile
              CrmAdminProfile={CrmAdminProfile}
              onClose={() => setIsCrmProfileModalOpen(false)} // pass close handler
            />
          </div>
        </div>
      )}

      {showCancelConfirmation && (
        <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-40 flex items-center justify-center z-50">
          <div className="bg-white rounded-md shadow-md p-6 max-w-sm text-center">
            <h2 className="text-lg font-semibold text-[#333]">
              Cancel Appointment?
            </h2>
            <p className="text-sm text-[#606060] mt-2">
              Are you sure you want to cancel this appointment?
            </p>
            {/* Reason + Remark Section for Cancel */}
            <div className="mt-3 space-y-3">
              {/* Reason Dropdown */}
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Reason for Cancellation
                </label>
                <select
                  value={cancelReason}
                  onChange={(e) => setCancelReason(e.target.value)}
                  className="w-full p-1 border rounded text-xs"
                >
                  <option value="">Select a reason</option>
                  <option value="by_patient">Cancelled by Patient</option>
                  <option value="by_doctor">Cancelled by Doctor</option>
                  <option value="clinic_closed">Clinic Closed</option>
                  <option value="emergency">Emergency</option>
                  <option value="other">Other</option>
                </select>
              </div>

              {/* Remark Input (optional, or required if "Other") */}

              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Remark
                </label>
                <textarea
                required
                  value={cancelRemark}
                  onChange={(e) => setCancelRemark(e.target.value)}
                  placeholder="Enter additional details..."
                  className="w-full p-1 border rounded text-sm resize-none"
                  rows={3}
                />
              </div>
              {error && (
                <p className=" flex justify-center text-red-600 text-[10px] mt-2">
                  {error}
                </p>
              )}
            </div>

            <div className="flex justify-center gap-4 mt-6">
              <button
                onClick={() => setShowCancelConfirmation(false)}
                className="px-4 py-2 text-sm bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
              >
                No, Keep
              </button>
              <button
                onClick={() => {
                  if (!cancelReason) {
                    setError("Please select a reason before cancelling.");
                    return;
                  }
                  if (!cancelRemark) {
                    setError("Please add a remark before cancelling.");
                    return;
                  }
                  setError(""); // clear errors
                  handleCancelAppointment();
                }}
                disabled={loading} // optional if you want a loading state
                className={`px-4 py-2 text-sm rounded text-white
    ${
      !cancelReason || !cancelRemark
        ? "bg-red-300 cursor-not-allowed"
        : "bg-red-500 hover:bg-red-600"
    }`}
              >
              {loading?"cancelling..":"Yes, Cancel"} 
              </button>
            </div>
          </div>
        </div>
      )}
      {showProfilePopup && (
        <PatientProfilePopup
          patientId={patientId !== null ? Number(patientId) : null}
          onClose={() => setShowProfilePopup(false)}
        />
      )}
      <div className="sticky top-0 shadow-sm z-[9999] ">
        <div className="flex justify-between items-center w-full h-[70px] bg-white px-2 xs:px-4 ">
          <div className="flex gap-3">
            <div
              className="xs:p-2  rounded-full  flex items-center justify-center cursor-pointer "
              onClick={() => setShowSidebar(!showSidebar)}
            >
              <GiHamburgerMenu className=" text-[#184A84] text-lg w-4 h-4 " />
            </div>
            <div className="flex items-center  flex-shrink-0">
              <a
                href="https://www.ramahospital.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={logo}
                  alt="Rama Hospital Logo"
                  className="h-[25px] w-[100px]"
                />
              </a>
            </div>
          </div>

          <div className="flex-grow min-w-[200px] max-w-lg px-5">
            <div className="relative w-full gap-5">
              <input
                type="text"
                className="w-full px-10 shadow-sm bg-[#F5F5F5] py-2 rounded-full focus:outline-none focus:ring-1 focus:ring-[#009A85] text-[14px] truncate"
                placeholder="Search by Patient Name, Appointment ID"
                onChange={(e) => setSearchTerm(e.target.value)}
              />

              {/* Search Icon */}

              <span className=" absolute top-1/2 transform -translate-y-1/2 right-1 text-[#184A84] rounded-full p-2 cursor-pointer ">
                <IoMdSearch />
              </span>
            </div>
          </div>
          <div className="flex justify-around gap-4">
            {/* <div className="p-2 rounded-full bg-[#F5F7FA] flex items-center justify-center hidden xs:inline ">
              <IoSettingsOutline className="text-[#184A84] text-lg"/>
            </div> */}
            {/* <div className="xs:p-2 rounded-full bg-[#F5F7FA] flex items-center justify-center">
              <FaRegBell className="text-[#184A84] text-lg" />
            </div> */}
          </div>
        </div>
      </div>

      <div className=" flex gap-3 relative">
        {/* sidebar */}
        {showSidebar && window.innerWidth < 1024 && (
          <div
            className="fixed inset-0 bg-white bg-opacity-10 z-20"
            onClick={() => setShowSidebar(false)}
          />
        )}
        {showSidebar && (
          <div
            className={`
      bg-white p-2 shadow-md z-30
      w-[250px] h-[calc(100vh-70px)]
      ${
        window.innerWidth < 1024
          ? "fixed top-[70px] left-0"
          : "md:relative md:sticky md:top-[70px]"
      }
    `}
          >
            {[
              { name: "Home", icon: <RiHome6Line className="text-lg" /> },
              {
                name: "Confirm",
                icon: <LiaHourglassHalfSolid className=" text-lg" />,
              },
              {
                name: "Scheduled",
                icon: <LuCalendarCheck className=" text-lg" />,
              },
              { name: "Active", icon: <LuNotepadText className=" text-lg" /> },
              {
                name: "Rescheduled",
                icon: <IoMdCalendar className=" text-lg" />,
              },
              {
                name: "Completed",
                icon: <IoCheckmarkDoneCircleOutline className=" text-lg" />,
              },
              {
                name: "Cancelled",
                icon: <RiCalendarCloseLine className=" text-lg" />,
              },
              { name: "Missed", icon: <MdCallMissed className=" text-lg" /> },
              {
                name: "Doctor Management",
                icon: <FaUserDoctor className=" text-lg" />,
              },
            ].map((item) => (
              <div
                key={item.name}
                onClick={() => {
                  setActivePage(item.name);
                  if (window.innerWidth < 1024) setShowSidebar(false);
                }}
                className={`flex items-center gap-4 pl-3 p-3 hover:bg-gray-100 hover:text-[#184A84] rounded-md cursor-pointer  ${
                  activePage === item.name
                    ? "bg-[#184A84]  text-white"
                    : "text-[#606060]"
                }`}
              >
                <p
                  className={`${
                    activePage === item.name
                      ? "text-white  hover:text-[#184A84]"
                      : "text-[#606060]  hover:text-[#184A84]"
                  }`}
                >
                  {item.icon}
                </p>
                <span className={` font-medium text-[14px] `}>{item.name}</span>
              </div>
            ))}
            <div className="w-[90%] absolute bottom-5">
              {/* User Info */}
              <div
                className="flex items-center gap-2 p-2 cursor-pointer"
                onClick={() => setIsCrmProfileModalOpen(true)}
              >
                {CrmAdminProfile?.profileImage ? (
                  <img
                    src={""}
                    alt="Patient"
                    className="w-[20px] h-[20px] rounded-full"
                  />
                ) : (
                  <img
                    src={Avtar}
                    alt="Patient"
                    className="w-7 h-7 rounded-full "
                  />
                )}

                <div className="w-[160px] overflow-hidden">
                  <h4 className="font-semibold text-black text-sm truncate w-full overflow-hidden truncate">
                    {CrmAdminProfile.username}
                  </h4>

                  <p className="text-xs text-gray-500 truncate ">
                    {CrmAdminProfile?.empId}
                  </p>
                </div>
              </div>
              {/* Logout Button */}
              <div
                onClick={handleLogoutClick}
                className="group flex items-center justify-center gap-2 w-full p-2 border border-[#184A84] rounded-md cursor-pointer hover:bg-[#184A84] transition"
              >
                <BiLogOut className="text-[#184A84] text-lg group-hover:text-white" />
                <span className="font-medium text-[14px] text-[#184A84] group-hover:text-white">
                  Logout
                </span>
              </div>
            </div>
          </div>
        )}
        {/* dynamic page  */}
        <div className="w-full">
          <div
            className={`
      fixed top-[70px] z-20 
      px-2  py-2 flex justify-between items-center 
      ${showSidebar ? "lg:w-[calc(100%-225px)] w-full" : "w-full "}
     
    `}
          >
            {/* Enhanced Status Tabs - Scrollable on All Screens */}
            <div className="overflow-x-auto whitespace-nowrap scrollbar-hide flex-1 custom- mr-2 custom-scrollbar">
              <div className="flex gap-1.5 sm:gap-3 min-w-max px-1 sm:px-2">
                {(() => {
                  const filteredCounts = getFilteredCounts();
                  const hasActiveFilters =
                    searchTerm.trim() || filters.speciality || dateRangeFilter;

                  return [
                    {
                      name: "Confirm",
                      count: hasActiveFilters
                        ? filteredCounts.Confirm
                        : count.Confirm,
                      color: "bg-amber-500",
                      textcolor: "text-amber-500",
                      border: "border-amber-500",
                      hoverColor: "hover:bg-amber-600",
                    },
                    {
                      name: "Scheduled",
                      count: hasActiveFilters
                        ? filteredCounts.Scheduled
                        : count.Scheduled,
                      color: "bg-blue-500",
                      textcolor: "text-blue-500",
                      border: "border-blue-500",
                      hoverColor: "hover:bg-blue-600",
                    },
                    {
                      name: "Active",
                      count: hasActiveFilters
                        ? filteredCounts.Active
                        : count.Active,
                      color: "bg-green-500",
                      textcolor: "text-green-500",
                      border: "border-green-500",
                      hoverColor: "hover:bg-green-600",
                    },
                    {
                      name: "Rescheduled",
                      count: hasActiveFilters
                        ? filteredCounts.Active
                        : count.Active,
                      color: "bg-purple-500",
                      textcolor: "text-purple-500",
                      border: "border-purple-500",
                      hoverColor: "hover:bg-purple-600",
                    },
                    {
                      name: "Completed",
                      count: hasActiveFilters
                        ? filteredCounts.Completed
                        : count.Completed,
                      color: "bg-emerald-500",
                      textcolor: "text-emerald-500",
                      border: "border-emerald-500",
                      hoverColor: "hover:bg-emerald-600",
                    },
                    {
                      name: "Cancelled",
                      count: hasActiveFilters
                        ? filteredCounts.Cancelled
                        : count.Cancelled,
                      color: "bg-red-500",
                      textcolor: "text-red-500",
                      border: "border-red-500",
                      hoverColor: "hover:bg-red-600",
                    },
                    {
                      name: "Missed",
                      count: hasActiveFilters
                        ? filteredCounts.Missed
                        : count.Missed,
                      color: "bg-orange-500",
                      textcolor: "text-orange-500",
                      border: "border-orange-500",
                      hoverColor: "hover:bg-gray-600",
                    },
                  ].map((item) => {
                    const isActive = activePage === item.name;

                    return (
                      <div
                        key={item.name}
                        onClick={() => setActivePage(item.name)}
                        className={`
                  cursor-pointer px-2 sm:px-4 py-2 rounded-lg flex items-center gap-2 min-w-fit 
                  relative group
                   ${
                     isActive
                       ? `bg-white text-[#184A84] shadow-md border-2 ${item.border} font-bold`
                       : "bg-white/90 hover:bg-white text-gray-700 border-2 hover:text-gray-900 shadow-sm"
                   }
                `}
                      >
                        
                        <div
                          className={`
                  w-6 h-6 sm:w-7 sm:h-7 rounded-full flex items-center justify-center text-white font-bold text-xs sm:text-sm
                  ${isActive ? item.color : item.color}
                  shadow-sm
                `}
                        >
                          {item.count}
                        </div>

                        {/* Status Name */}
                        <span
                          className={`
                  text-xs sm:text-sm font-medium
                  ${isActive ? `${item.textcolor}` : "text-gray-700"}
                `}
                        >
                          <span className="hidden sm:inline">{item.name}</span>
                          <span className="sm:hidden">
                            {item.name.slice(0, 4)}
                          </span>
                        </span>

                        {/* Hover Effect */}
                        <div className="absolute inset-0 rounded-lg bg-gradient-to-r from-transparent to-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-200"></div>
                      </div>
                    );
                  });
                })()}
              </div>
            </div>

            {/* Enhanced Date Filter Button for All Devices */}
            <div className="flex items-center gap-1 sm:gap-2">
              <button
                onClick={() => setShowDateFilterPopup(true)}
                className={`
      flex items-center gap-1 sm:gap-2 px-2 sm:px-3 py-1.5 rounded-md transition-all duration-200 text-xs sm:text-sm
      ${
        dateRangeFilter
          ? "bg-white text-[#184A84] shadow border border-[#184A84] font-medium"
          : "bg-white/20 hover:bg-white/30 text-black"
      }
    `}
              >
                <svg
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2z"
                  />
                </svg>
                <span className="hidden sm:inline font-medium">
                  {dateRangeFilter
                    ? dateRangeFilter === "custom"
                      ? "Custom Range"
                      : dateRangeFilter.charAt(0).toUpperCase() +
                        dateRangeFilter.slice(1)
                    : "Date Filter"}
                </span>
                <span className="sm:hidden font-medium">
                  {dateRangeFilter ? "Date" : "Filter"}
                </span>
                {dateRangeFilter && (
                  <span className="w-1.5 h-1.5 bg-orange-400 rounded-full"></span>
                )}
              </button>

              {/* Clear Filters Button */}
              {(searchTerm.trim() || filters.speciality || dateRangeFilter) && (
                <button
                  onClick={() => {
                    setSearchTerm("");
                    setFilters({
                      speciality: "",
                      doctor: "",
                      date: "",
                      priority: "",
                    });
                    setDateRangeFilter("");
                    setCustomDateRange({ from: "", to: "" });
                  }}
                  className="bg-red-500 hover:bg-red-600 text-white px-2 sm:px-3 py-1.5 rounded-md text-xs sm:text-sm font-medium shadow-sm transition-colors"
                >
                  <span className="hidden sm:inline">Clear All</span>
                  <span className="sm:hidden">Clear</span>
                </button>
              )}
            </div>
          </div>

          {/* Universal Date Filter Popup */}
          {showDateFilterPopup && (
            <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
              <div
                className="bg-white rounded-2xl shadow-2xl w-full max-w-md animate-scale-up overflow-hidden"
                onClick={(e) => e.stopPropagation()}
              >
                {/* Header */}
                <div className="flex justify-between items-center px-3 py-2 border-b border-gray-200">
                  <div className="flex items-center gap-2">
                    <div className="w-9 h-9 bg-[#184A84] rounded-full flex items-center justify-center">
                      <svg
                        className="w-5 h-5 text-white"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2z"
                        />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-base font-bold text-gray-900">
                        Date Filter
                      </h3>
                      <p className="text-xs text-gray-500">
                        Filter by date range
                      </p>
                    </div>
                  </div>
                  <button
                    onClick={() => setShowDateFilterPopup(false)}
                    className="p-1.5 hover:bg-gray-100 rounded-full transition-colors"
                  >
                    <svg
                      className="w-5 h-5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                </div>

                {/* Content */}
                <div className="px-3 py-3 space-y-3">
                  {/* Quick Options */}
                  <div>
                    <h4 className="text-xs font-semibold text-gray-700 mb-1">
                      Quick Options
                    </h4>
                    <div className="grid grid-cols-2 gap-2">
                      {[
                        { value: "", label: "All Dates" },
                        { value: "today", label: "Today" },
                        { value: "week", label: "This Week" },
                        { value: "month", label: "This Month" },
                      ].map((option) => (
                        <button
                          key={option.value}
                          onClick={() => {
                            setDateRangeFilter(option.value as any);
                            if (option.value !== "custom") {
                              setCustomDateRange({ from: "", to: "" });
                            }
                          }}
                          className={`
                  p-2 rounded-lg text-left border text-sm font-medium transition-all duration-200
                  ${
                    dateRangeFilter === option.value
                      ? "bg-[#184A84] text-white border-[#184A84] shadow-md"
                      : "bg-gray-50 hover:bg-gray-100 border-gray-200"
                  }
                `}
                        >
                          {option.label}
                        </button>
                      ))}
                    </div>
                  </div>

                  {/* Custom Range */}
                  <div className="border-t border-gray-200 pt-3">
                    <button
                      onClick={() => setDateRangeFilter("custom")}
                      className={`
              w-full p-2 rounded-lg text-left border transition-all duration-200 text-sm font-medium
              ${
                dateRangeFilter === "custom"
                  ? "bg-[#184A84] text-white border-[#184A84] shadow-md"
                  : "bg-gray-50 hover:bg-gray-100 border-gray-200"
              }
            `}
                    >
                      Custom Range
                    </button>

                    {dateRangeFilter === "custom" && (
                      <div className="mt-3 bg-gray-50 p-3 rounded-lg border border-gray-200 space-y-2">
                        <h5 className="text-xs font-semibold text-gray-700">
                          Select Date Range
                        </h5>
                        <div className="grid gap-2">
                          <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1">
                              From
                            </label>
                           <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
    label="From Date"
    value={customDateRange.from? dayjs(customDateRange.from) : null}
    onChange={(newValue) =>
      setCustomDateRange((prev) => ({
        ...prev,
        from: newValue ? newValue.format('YYYY-MM-DD') : '',
      }))
    }
    maxDate={dayjs()}
 
    slots={{
      textField: (params) => (
        <TextField
          {...params}
          fullWidth
          size="small"
          placeholder="Select from date"
          sx={{
            '& .MuiInputBase-root': {
              height: '40px',
              borderRadius: '6px',
              fontSize: '14px', // Match text-s
              '&:hover': {
                borderColor: '#184A84',
              },
              '&.Mui-focused': {
                borderColor: '#184A84',
                boxShadow: '0 0 0 2px rgba(24, 74, 132, 0.2)',
              }
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#d1d5db', 
            },
            '& .MuiInputLabel-root': {
              fontSize: '14px',
              '&.Mui-focused': {
                color: '#184A84',
              }
            }
          }}
        />
      )
    }}
    slotProps={{
      popper: {
        sx: {
          zIndex: 1400,
        }
      }
    }}
  />
</LocalizationProvider>

                          </div>
                          <div>
                            <label className="block text-xs font-medium text-gray-600 mb-1">
                              To
                            </label>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
    label="From Date"
    value={customDateRange.to? dayjs(customDateRange.to) : null}
    onChange={(newValue) =>
      setCustomDateRange((prev) => ({
        ...prev,
        to: newValue ? newValue.format('YYYY-MM-DD') : '',
      }))
    }
    maxDate={dayjs()}
 
    slots={{
      textField: (params) => (
        <TextField
          {...params}
          fullWidth
          size="small"
          placeholder="Select from date"
          sx={{
            '& .MuiInputBase-root': {
              height: '40px',
              borderRadius: '6px',
              fontSize: '14px', // Match text-s
              '&:hover': {
                borderColor: '#184A84',
              },
              '&.Mui-focused': {
                borderColor: '#184A84',
                boxShadow: '0 0 0 2px rgba(24, 74, 132, 0.2)',
              }
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#d1d5db', 
            },
            '& .MuiInputLabel-root': {
              fontSize: '14px',
              '&.Mui-focused': {
                color: '#184A84',
              }
            }
          }}
        />
      )
    }}
    slotProps={{
      popper: {
        sx: {
          zIndex: 1400,
        }
      }
    }}
  />
</LocalizationProvider>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Footer */}
                <div className="flex gap-2 px-3 py-2 border-t border-gray-200">
                  <button
                    onClick={() => {
                      setDateRangeFilter("");
                      setCustomDateRange({ from: "", to: "" });
                    }}
                    className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 py-2 rounded-lg text-sm font-medium transition-colors"
                  >
                    Reset
                  </button>
                  <button
                    onClick={() => setShowDateFilterPopup(false)}
                    className="flex-1 bg-[#184A84] hover:bg-[#0f3a6b] text-white py-2 rounded-lg text-sm font-medium transition-colors"
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          )}

          {activePage === "Home" && <HomePageDoctorCalender />}

          {activePage === "Confirm" && (
            <div className="ml-2 ">
              <div className="w-full">
                <div className="sticky top-[128px] sm:top-[140px] w-full bg-[#F5F5F5] pb-3 z-10 ">
                  <div className="flex justify-between">
                    <div className="w-[60%]">
                      <p className="text-[16px] font-semibold w-full">
                        Confirm Approval – Take Action
                      </p>
                      <p className="text-[12px] text-[#606060] w-full">
                        Let’s get this appointment scheduled!
                      </p>
                    </div>
                    <div className="flex justify-around  items-center  w-[30%] hidden sm:inline ">
                      <div className="flex justify-center  gap-3">
                        <div className="relative inline-block mt-2">
                          <select
                            onChange={(e) =>
                              setFilters((prev) => ({
                                ...prev,
                                speciality: e.target.value,
                              }))
                            }
                            value={filters.speciality || ""}
                            className="w-[150px] py-1 px-4 pr-8 rounded-md text-[12px] text-[#009A85] border-none appearance-none shadow-sm shadow-gray-400 focus:outline-none focus:ring-0"
                          >
                            <option className="text-black" value="">
                              All Specialities
                            </option>
                            {specialities.map((speciality: any) => (
                              <option
                                className="text-black"
                                key={speciality.specialization}
                                value={speciality.specialization}
                              >
                                {speciality.specialization}
                              </option>
                            ))}
                          </select>

                          {/* Custom arrow icon */}
                          <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center text-[#009A85] text-sm">
                            ▾
                          </div>
                        </div>
                        <p></p>
                        {/* <div className="flex items-center gap-3 border border-gray-500 py-1 px-4 rounded-full text-sm">
    Doctor
    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7"/>
    </svg>
  </div>
  <div className="flex items-center gap-3 border border-gray-500 py-1 px-4 rounded-full text-sm">
    Date
    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  </div>
  <div className="flex items-center gap-3 border border-gray-500 py-1 px-4 rounded-full text-sm">
    Priority
    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  </div> */}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className="w-[98%] rounded-md mt-12 flex-1 overflow-y-auto"
                  style={{ height: "calc(100vh - 216px)" }}
                >
                  <div className="hidden  sm:grid grid-cols-4 gap-2 mt-10 sm:mt-6 px-2 xl:pl-10 text-xs font-semibold text-gray-600 tracking-wider ">
                    <div className="border-r">Patient Info</div>
                    <div className="border-r xl:pl-2">Doctor Info</div>
                    <div className="xl:pl-2">Date & Time</div>
                    <div className="xl:pl-20">Action</div>
                  </div>
                  <div className="hidden sm:grid grid-cols-4 gap-2 mt-1 px-2 xl:pl-10 text-xs">
                    {/* Patient Search */}
                    <input
                      type="text"
                      placeholder="Search Patient"
                      className="text-xs px-3 py-1 rounded-md border border-gray-300 shadow-sm focus:ring-1 focus:ring-blue-400 focus:outline-none"
                      value={searchPatient}
                      onChange={(e) => setSearchPatient(e.target.value)}
                    />

                    {/* Doctor Search */}
                    <input
                      type="text"
                      placeholder="Search Doctor"
                      className="text-xs px-3 py-1 rounded-md border border-gray-300 shadow-sm focus:ring-1 focus:ring-blue-400 focus:outline-none"
                      value={searchDoctor}
                      onChange={(e) => setSearchDoctor(e.target.value)}
                    />

                    {/* Date Search */}
                    <input
                      type="text"
                      placeholder="Search Date"
                      className="text-xs px-3 py-1 rounded-md border border-gray-300 shadow-sm focus:ring-1 focus:ring-blue-400 focus:outline-none"
                      value={searchDate}
                      onChange={(e) => setSearchDate(e.target.value)}
                    />

                    <div></div>
                  </div>
                  {filteredAppointments.length == 0 && (
                    <div className=" text-center bg-white py-8 rounded-lg mt-5 sm:mt-2 font-semibold">
                      No Confirmed appointments at the moment.
                    </div>
                  )}
                  {filteredAppointments?.map((appointment: any, index: any) => (
                    <div
                      key={index}
                      className=" grid grid-cols-2 sm:grid-cols-4 gap-2 py-1 items-center bg-white p-2  sm:mt-2  xl:pl-10 rounded-xl border border-transparent hover:bg-[#D6E0F0] hover:border-[#B0C4DE] transition ease-in-out duration-200"
                    >
                      {/* <div className="absolute top-2 left-2 w-[5px] h-[5px] bg-red-500 rounded-full group-hover:w-[10px] group-hover:h-[10px] hover:bg-red-600 transition-all duration-200  "></div> */}
                      {/* Patient Info */}
                      <div className="border-r">
                        <p className="text-[14px] font-semibold">
                          {appointment.patientName}
                        </p>
                        <p className="text-xs text-gray-500">
                          Appointment ID:{appointment.appointmentId}, (
                          {appointment.age})yrs, {appointment.gender}
                        </p>
                      </div>
                      {/* Doctor Info */}
                      <div className="border-r  xl:pl-2">
                        <p className="text-[14px] font-semibold">
                          {appointment.doctorName}
                        </p>
                        <p className="text-xs text-gray-500">
                          {appointment.specializationName}
                        </p>
                      </div>
                      {/* Date & Time */}
                      <div className=" xl:pl-2">
                        <p className="text-[14px] text-[#184A84] font-semibold cursor-pointer">
                          {appointment.formattedDate}
                        </p>
                        <p className="text-xs text-[#184A84]">
                          {appointment.formattedTime}
                        </p>
                      </div>

                      {/* Confirm & Icons */}
                      <div className="flex items-center justify-between sm:justify-start gap-3 xl:pl-20">
                        <div className="flex flex-col items-center justify-between sm:justify-start gap-1">
                          <button
                            className={`text-white text-xs font-semibold px-8 py-1 rounded-md transition-all duration-200
    ${
      loadingAppointmentId === appointment.appointmentId
        ? "bg-gray-400 cursor-not-allowed"
        : "bg-[#184A84]"
    }`}
                            disabled={
                              loadingAppointmentId === appointment.appointmentId
                            }
                            onClick={() =>
                              handleMeetGenerate(
                                appointment.appointmentId,
                                appointment.appointmentDate,
                                appointment.slotStartTime,
                                appointment.slotEndTime,
                                appointment.email,
                                appointment.emailId,
                                appointment.doctorName,
                                appointment.patientName
                              )
                            }
                          >
                            Schedule
                          </button>
                          <button
                            className=" bg-[#009A85] hover:bg-[#038775] text-white text-xs font-semibold px-10 py-1 rounded-md transition-all duration-200"
                            onClick={() => {
                              setShowProfilePopup(true);
                              setPatientId(appointment.patientId);
                            }}
                          >
                            Profile
                          </button>
                          <div className="flex justify-around gap-3 mt-2">
                            <div className="flex gap-4">
                              {/* Reschedule */}
                              <div className="relative group">
                                <img
                                  src={reschedule}
                                  alt="Reschedule"
                                  className="w-6 h-6 cursor-pointer"
                                  onClick={() => {
                                    handleReschedule(
                                      appointment.doctorId,
                                      appointment.doctorFees,
                                      appointment.specializationName
                                    );
                                  }}
                                />
                                <span
                                  className="absolute  left-1/2 transform -translate-x-1/2 opacity-0
             group-hover:opacity-100 bg-[#394150] text-white text-xs rounded-md px-2 py-1"
                                >
                                  Reschedule
                                </span>
                              </div>
                              {isRecheduleModalOpen && (
                                <div
                                  className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-10"
                                  onClick={() =>
                                    setIsRescheduleModalOpen(false)
                                  }
                                >
                                  <div
                                    className="bg-white rounded-lg shadow-lg w-full sm:w-[70%] lg:w-[40%] max-w-3xl p-4 relative"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <h2 className=" text-center text-lg  font-semibold mb-2">
                                      Reschedule Appointment
                                    </h2>
                                    <div className="flex space-x-4 mb-2">
                                      <button
                                        className={` text-[12px] px-3 py-1 rounded ${
                                          rescheduleOption === "same"
                                            ? "bg-blue-600 text-white"
                                            : "bg-gray-200"
                                        }`}
                                        onClick={() =>
                                          setRescheduleOption("same")
                                        }
                                      >
                                        Reschedule with Same Doctor
                                      </button>
                                      <button
                                        className={` text-[12px]  px-3 py-1 rounded ${
                                          rescheduleOption === "different"
                                            ? "bg-blue-600 text-white"
                                            : "bg-gray-200"
                                        }`}
                                        onClick={() =>
                                          setRescheduleOption("different")
                                        }
                                      >
                                        Change Doctor
                                      </button>
                                    </div>

                                    {/* If Same Doctor */}
                                    {rescheduleOption === "same" && (
                                      <div>
                                        {selectedDoctor && (
                                          <DoctorAppointmentSlot
                                            doctor={SlectedDoctorId}
                                            appointmentId={
                                              appointment.appointmentId
                                            }
                                            emailId={appointment.emailId}
                                            email={appointment.email}
                                            doctorFees={appointment.doctorFees}
                                            patientId={appointment.patientId}
                                            doctorName={appointment.doctorName}
                                            patientName={
                                              appointment.patientName
                                            }
                                            onCloseModal={() =>
                                              setIsRescheduleModalOpen(false)
                                            }
                                          />
                                        )}
                                      </div>
                                    )}

                                    {/* If Different Doctor */}
                                    {rescheduleOption === "different" && (
                                      <div className=" gap-5 w-full">
                                        {/* Doctor List */}
                                        <select
                                          value={doctorId ?? ""}
                                          onChange={(e) => {
                                            const selectedId = parseInt(
                                              e.target.value,
                                              10
                                            );
                                            const selected: any =
                                              AvailableDoctors.find(
                                                (doc) =>
                                                  doc.doctorId === selectedId
                                              );
                                            if (selected) {
                                              setDoctorId(selected.doctorId);
                                              handleDoctorSelect(selected);
                                            }
                                          }}
                                          className="p-1 border rounded  text-xs"
                                        >
                                          <option key={0} value={0}>
                                            Choose Doctor
                                          </option>
                                          {AvailableDoctors.map((doc: any) => (
                                            <option
                                              key={doc.doctorId}
                                              value={doc.doctorId}
                                            >
                                              {doc.doctorName} —{" "}
                                              {doc.specializationName}
                                            </option>
                                          ))}
                                        </select>

                                        {selectedDoctor && (
                                          <DoctorAppointmentSlot
                                            doctor={doctorId}
                                            appointmentId={
                                              appointment.appointmentId
                                            }
                                            emailId={appointment.emailId}
                                            email={appointment.email}
                                            doctorFees={appointment.doctorFees}
                                            patientId={appointment.patientId}
                                            doctorName={appointment.doctorName}
                                            patientName={
                                              appointment.patientName
                                            }
                                            onCloseModal={() =>
                                              setIsRescheduleModalOpen(false)
                                            }
                                          />
                                        )}
                                      </div>
                                    )}
                                    {/* Footer */}
                                    <div className="mt-4 flex justify-end space-x-2 text-[12px]">
                                      <button
                                        className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-1 rounded"
                                        onClick={() =>
                                          setIsRescheduleModalOpen(false)
                                        }
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {/* Cancel */}
                              <div className="relative group">
                                <img
                                  src={cancel}
                                  alt="Cancel"
                                  className="w-6 h-6 cursor-pointer"
                                  onClick={() => {
                                    setSelectedAppointmentId(
                                      appointment.appointmentId
                                    );
                                    setShowCancelConfirmation(true);
                                  }}
                                />
                                <span className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 bg-[#FF0707] text-white text-xs rounded-md px-2 py-1">
                                  Cancel
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <PaginationControls
                  currentPage={currentPage}
                  totalPages={totalPages}
                  itemsPerPage={itemsPerPage}
                  onPageChange={setCurrentPage}
                  onItemsPerPageChange={setItemsPerPage}
                />
              </div>
            </div>
          )}
          {activePage === "Scheduled" && (
            <div className="ml-2">
              <div className="w-full">
                <div className="sticky top-[128px] sm:top-[140px]   w-full bg-[#F5F5F5] pb-3 z-10">
                  <div className="flex justify-between">
                    <div>
                      <p className="text-[16px] font-semibold w-full">
                        Scheduled Approval – Take Action
                      </p>
                      <p className="text-[12px] text-[#606060] w-full">
                        Please review or reschedule the appointment.
                      </p>
                    </div>
                    <div className="flex justify-around  items-center  w-[30%] hidden sm:inline ">
                      <div className="flex justify-center  gap-3">
                        <div className="relative inline-block mt-2">
                          <select
                            onChange={(e) =>
                              setFilters((prev) => ({
                                ...prev,
                                speciality: e.target.value,
                              }))
                            }
                            value={filters.speciality || ""}
                            className="w-[150px] py-1 px-4 pr-8 rounded-md text-[12px] text-[#009A85] border-none appearance-none shadow-sm shadow-gray-400 focus:outline-none focus:ring-0"
                          >
                            <option className="text-black" value="">
                              All Specialities
                            </option>
                            {specialities.map((speciality: any) => (
                              <option
                                className="text-black"
                                key={speciality.specialization}
                                value={speciality.specialization}
                              >
                                {speciality.specialization}
                              </option>
                            ))}
                          </select>

                          {/* Custom arrow icon */}
                          <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center text-[#009A85] text-sm">
                            ▾
                          </div>
                        </div>
                        <p> </p>
                        {/* <div className="flex items-center gap-3 border border-gray-500 py-1 px-4 rounded-full text-sm">
    Doctor
    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  </div>
  <div className="flex items-center gap-3 border border-gray-500 py-1 px-4 rounded-full text-sm">
    Date
    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  </div>
  <div className="flex items-center gap-3 border border-gray-500 py-1 px-4 rounded-full text-sm">
    Priority 
    <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  </div> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="w-[98%] rounded-md mt-12  flex-1 overflow-y-auto "
                  style={{ height: "calc(100vh - 216px)" }}
                >
                  <div className="hidden sm:grid grid-cols-4 gap-2 mt-6 px-2 xl:pl-10 text-xs font-semibold text-gray-600 tracking-wider ">
                    <div className="border-r">Patient Info</div>
                    <div className="border-r xl:pl-2">Doctor Info</div>
                    <div className="xl:pl-2">Date & Time</div>
                    <div className="xl:pl-20">Action</div>
                  </div>
                  <div className="hidden sm:grid grid-cols-4 gap-2 mt-1 px-2 xl:pl-10 text-xs">
                    {/* Patient Search */}
                    <input
                      type="text"
                      placeholder="Search Patient"
                      className="text-xs px-3 py-1 rounded-md border border-gray-300 shadow-sm focus:ring-1 focus:ring-blue-400 focus:outline-none"
                      value={searchPatient}
                      onChange={(e) => setSearchPatient(e.target.value)}
                    />
                    {/* Doctor Search */}
                    <input
                      type="text"
                      placeholder="Search Doctor"
                      className="text-xs px-3 py-1 rounded-md border border-gray-300 shadow-sm focus:ring-1 focus:ring-blue-400 focus:outline-none"
                      value={searchDoctor}
                      onChange={(e) => setSearchDoctor(e.target.value)}
                    />
                    {/* Date Search */}
                    <input
                      type="text"
                      placeholder="Search Date"
                      className="text-xs px-3 py-1 rounded-md border border-gray-300 shadow-sm focus:ring-1 focus:ring-blue-400 focus:outline-none"
                      value={searchDate}
                      onChange={(e) => setSearchDate(e.target.value)}
                    />
                    <div></div> {/* spacer for action column */}
                  </div>
                  {filteredAppointments.length == 0 && (
                    <div className=" text-center bg-white py-8 rounded-lg mt-2 font-semibold">
                      No Scheduled appointments at the moment.
                      {/* {""} */}
                    </div>
                  )}
                  {filteredAppointments?.map((appointment: any, index: any) => (
                    <div
                      key={index}
                      className=" grid grid-cols-2 sm:grid-cols-4 gap-2 py-2 items-center bg-white p-2 mt-1 xl:pl-10 rounded-xl border border-transparent hover:bg-[#D6E0F0] hover:border-[#B0C4DE] transition ease-in-out duration-200"
                    >
                      {/* <div className="absolute top-2 left-2 w-[5px] h-[5px] bg-red-500 rounded-full group-hover:w-[10px] group-hover:h-[10px] hover:bg-red-600 transition-all duration-200  "></div> */}
                      {/* Patient Info */}
                      <div className="border-r">
                        <p className="text-[14px] font-semibold">
                          {appointment.patientName}
                        </p>
                        <p className="text-xs text-gray-500">
                          Appointment ID:{appointment.appointmentId}, (
                          {appointment.age})yrs,
                          {appointment.gender}
                        </p>
                      </div>

                      {/* Doctor Info */}
                      <div className="border-r xl:pl-2">
                        <p className="text-[14px] font-semibold">
                          {appointment.doctorName}
                        </p>
                        <p className="text-xs text-gray-500">
                          {appointment.specializationName}
                        </p>
                      </div>
                      {/* Date & Time */}
                      <div className="xl:pl-2">
                        <p className="text-[14px] text-[#184A84] font-semibold cursor-pointer">
                          {appointment.formattedDate}
                        </p>
                        <p className="text-xs text-[#184A84]">
                          {appointment.formattedTime}
                        </p>
                      </div>

                      {/* Confirm & Icons */}
                      <div className="flex items-center justify-between sm:justify-start gap-3 xl:pl-20">
                        <div>
                          <button
                            className="bg-[#009A85] text-white text-xs font-semibold px-10 py-[5px] rounded-md hover:bg-[#038775]"
                            onClick={() => {
                              setShowProfilePopup(true);
                              setPatientId(appointment.patientId);
                            }}
                          >
                            Profile
                          </button>
                          <div className="flex justify-around gap-3 mt-2">
                            <div className="flex gap-4">
                              {/* Reschedule */}
                              <div className="relative group">
                                <img
                                  src={reschedule}
                                  alt="Reschedule"
                                  className="w-6 h-6 cursor-pointer"
                                  onClick={() => {
                                    handleReschedule(
                                      appointment.doctorId,
                                      appointment.doctorFees,
                                      appointment.specializationName
                                    );
                                  }}
                                />
                                <span
                                  className="absolute  left-1/2 transform -translate-x-1/2 opacity-0
             group-hover:opacity-100 bg-[#394150] text-white text-xs rounded-md px-2 py-1"
                                >
                                  Reschedule
                                </span>
                              </div>
                              {isRecheduleModalOpen && (
                                <div
                                  className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-10"
                                  onClick={() =>
                                    setIsRescheduleModalOpen(false)
                                  }
                                >
                                  <div
                                    className="bg-white rounded-lg shadow-lg w-full sm:w-[70%] lg:w-[50%] max-w-4xl p-4 relative"
                                    onClick={(e) => e.stopPropagation()}
                                  >
                                    <h2 className=" text-center text-lg  font-semibold mb-2">
                                      Reschedule Appointment
                                    </h2>
                                    <div className="flex space-x-4 mb-2">
                                      <button
                                        className={` text-[12px] px-3 py-1 rounded ${
                                          rescheduleOption === "same"
                                            ? "bg-blue-600 text-white"
                                            : "bg-gray-200"
                                        }`}
                                        onClick={() =>
                                          setRescheduleOption("same")
                                        }
                                      >
                                        Reschedule with Same Doctor
                                      </button>
                                      <button
                                        className={` text-[12px]  px-3 py-1 rounded ${
                                          rescheduleOption === "different"
                                            ? "bg-blue-600 text-white"
                                            : "bg-gray-200"
                                        }`}
                                        onClick={() =>
                                          setRescheduleOption("different")
                                        }
                                      >
                                        Change Doctor
                                      </button>
                                    </div>

                                    {/* If Same Doctor */}
                                    {rescheduleOption === "same" && (
                                      <div>
                                        {selectedDoctor && (
                                          <DoctorAppointmentSlot
                                            doctor={SlectedDoctorId}
                                            appointmentId={
                                              appointment.appointmentId
                                            }
                                            emailId={appointment.emailId}
                                            email={appointment.email}
                                            doctorFees={appointment.doctorFees}
                                            patientId={appointment.patientId}
                                            doctorName={appointment.doctorName}
                                            patientName={
                                              appointment.patientName
                                            }
                                            onCloseModal={() =>
                                              setIsRescheduleModalOpen(false)
                                            }
                                          />
                                        )}
                                      </div>
                                    )}

                                    {/* If Different Doctor */}
                                    {rescheduleOption === "different" && (
                                      <div className=" gap-5 w-full">
                                        {/* Doctor List */}
                                        <select
                                          value={doctorId ?? ""}
                                          onChange={(e) => {
                                            const selectedId = parseInt(
                                              e.target.value,
                                              10
                                            );
                                            const selected: any =
                                              AvailableDoctors.find(
                                                (doc) =>
                                                  doc.doctorId === selectedId
                                              );
                                            if (selected) {
                                              setDoctorId(selected.doctorId);
                                              handleDoctorSelect(selected);
                                            }
                                          }}
                                          className="p-2 border rounded w- text-sm"
                                        >
                                          <option key={0} value={0}>
                                            Choose Doctor
                                          </option>
                                          {AvailableDoctors.map((doc: any) => (
                                            <option
                                              key={doc.doctorId}
                                              value={doc.doctorId}
                                            >
                                              {doc.doctorName} —{" "}
                                              {doc.specializationName}
                                            </option>
                                          ))}
                                        </select>

                                        {selectedDoctor && (
                                          <DoctorAppointmentSlot
                                            doctor={doctorId}
                                            appointmentId={
                                              appointment.appointmentId
                                            }
                                            emailId={appointment.emailId}
                                            email={appointment.email}
                                            doctorFees={appointment.doctorFees}
                                            patientId={appointment.patientId}
                                            doctorName={appointment.doctorName}
                                            patientName={
                                              appointment.patientName
                                            }
                                            onCloseModal={() =>
                                              setIsRescheduleModalOpen(false)
                                            }
                                          />
                                        )}
                                      </div>
                                    )}
                                    {/* Footer */}
                                    <div className="mt-4 flex justify-end space-x-2 text-[12px]">
                                      <button
                                        className="bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-1 rounded"
                                        onClick={() =>
                                          setIsRescheduleModalOpen(false)
                                        }
                                      >
                                        Cancel
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {/* Cancel */}
                              <div className="relative group">
                                <img
                                  src={cancel}
                                  alt="Cancel"
                                  className="w-6 h-6 cursor-pointer"
                                  onClick={() => {
                                    setSelectedAppointmentId(
                                      appointment.appointmentId
                                    );
                                    setShowCancelConfirmation(true);
                                  }}
                                />
                                <span className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 opacity-0 group-hover:opacity-100 bg-[#FF0707] text-white text-xs rounded-md px-2 py-1">
                                  Cancel
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                <PaginationControls
                  currentPage={currentPage}
                  totalPages={totalPages}
                  itemsPerPage={itemsPerPage}
                  onPageChange={setCurrentPage}
                  onItemsPerPageChange={setItemsPerPage}
                />
              </div>
            </div>
          )}
          {activePage === "Active" && (
            <div className="ml-2">
              <div className="w-full">
                <div className="sticky top-[128px] sm:top-[140px]   w-full bg-[#F5F5F5] pb-3 z-10">
                  <div className="flex justify-between">
                    <div>
                      <p className="text-[16px] font-semibold w-full">
                        Active Approved – Take Action
                      </p>
                      <p className="text-[12px] text-[#606060] w-full">
                        Approved appointment – consultation starting shortly
                      </p>
                    </div>
                    <div className="flex justify-around  items-center  w-[30%] hidden sm:inline ">
                      <div className="flex justify-center  gap-3">
                        <div className="relative inline-block mt-2">
                          <select
                            onChange={(e) =>
                              setFilters((prev) => ({
                                ...prev,
                                speciality: e.target.value,
                              }))
                            }
                            value={filters.speciality || ""}
                            className="w-[150px] py-1 px-4 pr-8 rounded-md text-[12px] text-[#009A85] border-none appearance-none shadow-sm shadow-gray-400 focus:outline-none focus:ring-0"
                          >
                            <option className="text-black" value="">
                              All Specialities
                            </option>
                            {specialities.map((speciality: any) => (
                              <option
                                className="text-black"
                                key={speciality.specialization}
                                value={speciality.specialization}
                              >
                                {speciality.specialization}
                              </option>
                            ))}
                          </select>

                          <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center text-[#009A85] text-sm">
                            ▾
                          </div>
                        </div>
                        <p> </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="w-[98%] rounded-md mt-12  flex-1 overflow-y-auto "
                  style={{ height: "calc(100vh - 216px)" }}
                >
                  <div className="hidden sm:grid grid-cols-4 gap-2 mt-6 px-2 xl:pl-10 text-xs font-semibold text-gray-600 tracking-wider ">
                    <div className="border-r">Patient Info</div>
                    <div className="border-r xl:pl-2">Doctor Info</div>
                    <div className="xl:pl-2">Date & Time</div>
                    <div className="xl:pl-20">Action</div>
                  </div>{" "}
                  <div className="hidden sm:grid grid-cols-4 gap-2 mt-1 px-2 xl:pl-10 text-xs">
                    {/* Patient Search */}
                    <input
                      type="text"
                      placeholder="Search Patient"
                      className="text-xs px-3 py-1 rounded-md border border-gray-300 shadow-sm focus:ring-1 focus:ring-blue-400 focus:outline-none"
                      value={searchPatient}
                      onChange={(e) => setSearchPatient(e.target.value)}
                    />

                    {/* Doctor Search */}
                    <input
                      type="text"
                      placeholder="Search Doctor"
                      className="text-xs px-3 py-1 rounded-md border border-gray-300 shadow-sm focus:ring-1 focus:ring-blue-400 focus:outline-none"
                      value={searchDoctor}
                      onChange={(e) => setSearchDoctor(e.target.value)}
                    />

                    {/* Date Search */}
                    <input
                      type="text"
                      placeholder="Search Date"
                      className="text-xs px-3 py-1 rounded-md border border-gray-300 shadow-sm focus:ring-1 focus:ring-blue-400 focus:outline-none"
                      value={searchDate}
                      onChange={(e) => setSearchDate(e.target.value)}
                    />

                    <div></div>
                    {/* spacer for action column */}
                  </div>
                  {filteredAppointments.length == 0 && (
                    <div className=" text-center bg-white py-8 rounded-lg mt-2 font-semibold">
                      No Active appointments at the moment.
                    </div>
                  )}
                  {filteredAppointments?.map((appointment: any, index: any) => (
                    <div
                      key={index}
                      className=" grid grid-cols-1 sm:grid-cols-4 gap-2 py-2 items-center bg-white p-2 mt-1 xl:pl-10 rounded-xl border border-transparent hover:bg-[#D6E0F0] hover:border-[#B0C4DE] transition ease-in-out duration-200"
                    >
                      {/* <div className="absolute top-2 left-2 w-[5px] h-[5px] bg-red-500 rounded-full group-hover:w-[10px] group-hover:h-[10px] hover:bg-red-600 transition-all duration-200  "></div> */}
                      {/* Patient Info */}
                      <div className="border-r">
                        <p className="text-[14px] font-semibold">
                          {appointment.patientName}
                        </p>
                        <p className="text-xs text-gray-500">
                          Appointment ID: {appointment.appointmentId} , (
                          {appointment.age})yrs, {appointment.gender}
                        </p>
                      </div>
                      {/* Doctor Info */}
                      <div className="border-r  xl:pl-2">
                        <p className="text-[14px] font-semibold">
                          {appointment.doctorName}
                        </p>
                        <p className="text-xs text-gray-500">
                          {appointment.specializationName}
                        </p>
                      </div>
                      {/* Date & Time */}
                      <div className=" xl:pl-2">
                        <p className="text-[14px] text-[#184A84] font-semibold cursor-pointer">
                          {appointment.formattedDate}
                        </p>
                        <p className="text-xs text-[#184A84]">
                          {appointment.formattedTime}
                        </p>
                      </div>
                      {/* Confirm & Icons */}
                      <div className="flex flex-col items-center justify-between sm:justify-start gap-3 xl:pl-20">
                        <div className="flex flex-col gap-1">
                          <button
                            className="w-[140px] bg-[#009A85] text-white text-xs font-semibold px-5 py-[5px] rounded-md hover:bg-[#038775]"
                            onClick={() =>
                              window.open(
                                appointment.meetLink,
                                "Appointment with doctor"
                              )
                            }
                          >
                            Start Meeting
                          </button>
                          <button
                            className="w-[140px] bg-[#009A85] text-white text-xs font-semibold px-5 py-[5px] rounded-md hover:bg-[#038775]"
                            onClick={() => {
                              setShowProfilePopup(true);
                              setPatientId(appointment.patientId);
                            }}
                          >
                            Profile
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <PaginationControls
                  currentPage={currentPage}
                  totalPages={totalPages}
                  itemsPerPage={itemsPerPage}
                  onPageChange={setCurrentPage}
                  onItemsPerPageChange={setItemsPerPage}
                />
              </div>
            </div>
          )}

         {activePage === "Rescheduled" && (
  <CrmDashboards
    page="Rescheduled"
    title="Rescheduled Approval – Take Action"
    subtitle="You've successfully rescheduled — now just one step away from the consultation!"
    noDataMessage="No Rescheduled appointments at the moment."
    appointments={currentAppointments}
    allAppointments={allAppointments} 
    filters={filters}
    setFilters={setFilters}
    specialities={specialities}
    currentPage={currentPage}
    totalPages={totalPages}
    setCurrentPage={setCurrentPage}
    setShowProfilePopup={setShowProfilePopup}
    itemsPerPage={itemsPerPage}
    setItemsPerPage={setItemsPerPage}
  />
)}

{activePage === "Cancelled" && (
  <CrmDashboards
    page="Cancelled"
    title="Cancelled Appointments"
    subtitle="This appointment was cancelled. No further action is required."
    noDataMessage="No Cancelled appointments at the moment."
    appointments={currentAppointments} 
    allAppointments={allAppointments}
    filters={filters}
    setFilters={setFilters}
    specialities={specialities}
    currentPage={currentPage}
    totalPages={totalPages}
    setCurrentPage={setCurrentPage}
    setShowProfilePopup={setShowProfilePopup}
    itemsPerPage={itemsPerPage}
    setItemsPerPage={setItemsPerPage}
  />
)}

{activePage === "Completed" && (
  <CrmDashboards
    page="Completed"
    title="Completed Appointment"
    subtitle="This appointment is completed. Thank you for your time!"
    noDataMessage="No Completed appointments at the moment."
    appointments={currentAppointments} 
    allAppointments={allAppointments} 
    filters={filters}
    setFilters={setFilters}
    specialities={specialities}
    currentPage={currentPage}
    totalPages={totalPages}
    setCurrentPage={setCurrentPage}
    setShowProfilePopup={setShowProfilePopup}
    itemsPerPage={itemsPerPage}
    setItemsPerPage={setItemsPerPage}
  />
)}

{activePage === "Missed" && (
  <CrmDashboards
    page="Missed"
    title="Missed Appointment"
    subtitle="This appointment was missed. Please follow up or reschedule if needed."
    noDataMessage="No Missed appointments at the moment."
    appointments={currentAppointments} 
    allAppointments={allAppointments}
    filters={filters}
    setFilters={setFilters}
    specialities={specialities}
    currentPage={currentPage}
    totalPages={totalPages}
    setCurrentPage={setCurrentPage}
    setShowProfilePopup={setShowProfilePopup}
    itemsPerPage={itemsPerPage}
    setItemsPerPage={setItemsPerPage}
  />
)}
          {activePage === "Doctor Management" && <SlotsDoctorAvailability />}
        </div>
      </div>
    </div>
  );
};
export default CrmDashboard;
